import { useQuery } from '@tanstack/react-query';
import { getFixedCostSettings, FixedCostSettingsResponse } from '../../../api/FixedCostSettings/fixedCostSettings';

export function useGetFixedCostSettings() {
  const getQuery = useQuery({
    queryKey: [ 'getFixedCostSettings' ],
    queryFn: () => getFixedCostSettings()
  });

  return {
    data: (getQuery.data?.data.results as FixedCostSettingsResponse) || null,
    error: getQuery.error || null,
    isLoading: getQuery.isLoading,
    refetch: getQuery.refetch
  };
}
